import { render, staticRenderFns } from "./xueli.vue?vue&type=template&id=67562e3d&"
import script from "./xueli.vue?vue&type=script&lang=js&"
export * from "./xueli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports